import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appInputPrefix]',
})
export class InputPrefixDirective {
  constructor(el: ElementRef<HTMLElement>) {
    el.nativeElement.tabIndex = -1;
  }
}
